import Company from './Company/Company.vue'
import Confirmation from './Confirmation/Confirmation.vue'
import Legal from './Legal/Legal.vue'
import Logo from './Logo/Logo.vue'
import Reset from './Reset/Reset.vue'
import Welcome from './Welcome/Welcome.vue'

export {
  Company,
  Confirmation,
  Legal,
  Logo,
  Reset,
  Welcome
}



// WEBPACK FOOTER //
// ./src/assets/pages/index.js